import { OnInit, Component, Inject, Injector, Input, PLATFORM_ID, ViewEncapsulation } from '@angular/core';
import { AbstractComponent } from './../abstract.component';
import { Module } from 'projects/common/model/ModuleModel';
import { FavoriteCardTypeEnum, FavoriteProductEnum, UserFavoriteData, UserFavoriteSortBy } from './../user-favorites/user-favorite-data.model';
import { Currency } from 'projects/common/model/landingModel';
import { FlightOffersData } from './flight-offers-data.model';
import { OfferCardData, OfferCardType } from '../offers/offer-card-data.model';
import { Device } from 'projects/common/model/Device';


declare var window: any;

@Component({
  selector: 'flight-offers',
  template: `
      <ng-container>
        <offers *ngIf="isOfferCardView()"
          [module]="castModule(getOffersModule())" [currency]="currency" [flow]="flow" [allRowVisible]="allRowVisible"></offers>
      
        <user-favorites *ngIf="isFlightCardView()"
          [gridOptions]="module.data.grid_options"
          [sliderOptions]="module.data.slider_options"
          [module]="getFavoritesModule()"
          [product]="product"
          [flow]="flow"
          [nextFlow]="module.data.next_flow"
          [device]="device"
          [currency]="currency" ></user-favorites>
      </ng-container>
  `,
  styleUrls: ['./flight-offers.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class FlightOffersComponent extends AbstractComponent implements OnInit {
  @Input() override module: Module<FlightOffersData>;
  @Input() override flow: string;
  @Input() currency: Currency;
  @Input() moduleIndex: number;
  @Input() allRowVisible: boolean;
  @Input() device: Device;

  override product: string;
  offersView: OfferCardType;

  currentSortBy: UserFavoriteSortBy | null;
  groupedFavorites: any = {};
  isGroupedFavoritesEmpty: boolean = true;
  FavoriteCardTypeEnum = FavoriteCardTypeEnum;

  constructor(injector: Injector, @Inject(PLATFORM_ID) private platformId: string) {
    super(injector);
    this.product = FavoriteProductEnum.FLIGHT;
  }

  ngOnInit() {
    this.offersView = this.module.data.offers_view
  }

  isOfferCardView() {
    return this.offersView === OfferCardType.COMMON;
  }

  isFlightCardView() {
    return this.offersView === OfferCardType.FLIGHT_LANDING ||
      this.offersView === OfferCardType.SUMMARY;
  }

  getOffersModule(): Module<OfferCardData[]> {
    let {data, ...rest} = this.module
    return {data: data.offers, ...rest}
  }

  castModule<M extends Module, T extends M>(module: M): T {
    return module as T;
  }

  getFavoritesModule(): Module<UserFavoriteData> {
    let {data, ...rest} = this.module
    return {data: data.favorites_response, ...rest}
  }

  getModuleId(): string {
    return "FlightOffersModule";
  }

}
